<div class="toast-container" *ngIf="toastSvc.toasts().length">
  <div class="toast" *ngFor="let t of toastSvc.toasts()" [ngClass]="t.type" (click)="dismiss(t.id)">
    <span class="ic">{{ iconFor(t.type) }}</span>
    <span class="msg">{{ t.message }}</span>
  </div>
</div>
